var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { themeit } from 'react-themeit';

import Duration from './Duration';

import baseStyle from './styles.less';
import _taskQuestion from './themes/taskQuestion.less';

var themeOptions = {
  base: function base(cb) {
    return cb(baseStyle);
  },
  themes: {
    taskQuestion: function taskQuestion(cb) {
      return cb(_taskQuestion);
    }
  }
};

var MediaController = function (_Component) {
  _inherits(MediaController, _Component);

  function MediaController() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, MediaController);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MediaController.__proto__ || Object.getPrototypeOf(MediaController)).call.apply(_ref, [this].concat(args))), _this), _this.onKeyDown = function (e) {
      var _this$props = _this.props,
          setPlayingState = _this$props.setPlayingState,
          playing = _this$props.playing;

      if (e.keyCode === 32) {
        setPlayingState(!playing);
      }
    }, _this.toggle = function () {
      var _this$props2 = _this.props,
          toggleAudioSource = _this$props2.toggleAudioSource,
          setToPosition = _this$props2.setToPosition;

      toggleAudioSource();
      setToPosition(0);
    }, _this.timelineClick = function (e) {
      var _this$props3 = _this.props,
          setToPosition = _this$props3.setToPosition,
          duration = _this$props3.duration;

      setToPosition(_this.clickPercent(e) * duration);
    }, _this.clickPercent = function (e) {
      var clientX = e.clientX || e.changedTouches[0].clientX;
      return (clientX - _this.$timeline.getBoundingClientRect().left) / _this.$timeline.offsetWidth;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(MediaController, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('keydown', this.onKeyDown);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('keydown', this.onKeyDown);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          playing = _props.playing,
          elapsed = _props.elapsed,
          duration = _props.duration,
          onSeekMouseDown = _props.onSeekMouseDown,
          onSeekChange = _props.onSeekChange,
          onSeekMouseUp = _props.onSeekMouseUp,
          setPlayingState = _props.setPlayingState,
          setToPosition = _props.setToPosition,
          vocalsIcon = _props.vocalsIcon,
          jumpStepInSeconds = _props.jumpStepInSeconds,
          styles = _props.styles,
          hasSourceToggle = _props.hasSourceToggle;

      var currentTime = duration * elapsed;
      return React.createElement(
        'div',
        { className: styles.mediaContainer, role: 'button' },
        React.createElement(
          'div',
          {
            className: styles.elements
          },
          React.createElement('span', {
            role: 'button',
            className: 'icon-previous ' + styles.iconPlay,
            onClick: function onClick() {
              return setToPosition(0);
            }
          }),
          React.createElement('span', {
            role: 'button',
            className: 'icon-backward ' + styles.iconPlay,
            onClick: function onClick() {
              return setToPosition(currentTime - jumpStepInSeconds);
            }
          }),
          React.createElement('span', {
            role: 'button',
            className: styles.iconPlay + ' ' + (playing ? 'icon-pause' : 'icon-play'),
            onClick: function onClick() {
              return setPlayingState(!playing);
            }
          }),
          React.createElement('span', {
            role: 'button',
            className: 'icon-forward ' + styles.iconPlay,
            onClick: function onClick() {
              return setToPosition(currentTime + jumpStepInSeconds);
            }
          }),
          hasSourceToggle && React.createElement('span', {
            role: 'button',
            className: (vocalsIcon ? 'icon-toggle-lyrics-on' : 'icon-toggle-lyrics-off') + ' ' + styles.iconPlay,
            onClick: this.toggle
          }),
          React.createElement(Duration, { className: styles.time, seconds: currentTime }),
          React.createElement('input', {
            className: styles.timeline,
            type: 'range',
            min: 0,
            max: 1,
            step: 'any',
            value: Number.isNaN(elapsed) ? 0 : elapsed,
            onMouseDown: onSeekMouseDown,
            onTouchStart: onSeekMouseDown,
            onChange: onSeekChange,
            onMouseUp: onSeekMouseUp,
            onTouchEnd: onSeekMouseUp
          }),
          React.createElement(Duration, { className: styles.time, seconds: duration })
        )
      );
    }
  }]);

  return MediaController;
}(Component);

MediaController.propTypes = process.env.NODE_ENV !== "production" ? {
  playing: PropTypes.bool.isRequired,
  elapsed: PropTypes.number.isRequired,
  duration: PropTypes.number.isRequired,
  onSeekMouseDown: PropTypes.func.isRequired,
  onSeekChange: PropTypes.func.isRequired,
  onSeekMouseUp: PropTypes.func.isRequired,
  setPlayingState: PropTypes.func.isRequired,
  setToPosition: PropTypes.func.isRequired,
  hasSourceToggle: PropTypes.bool,
  vocalsIcon: PropTypes.bool,

  toggleAudioSource: PropTypes.func,
  jumpStepInSeconds: PropTypes.number,

  styles: PropTypes.objectOf(PropTypes.string)
} : {};

MediaController.defaultProps = {
  toggleAudioSource: null,
  jumpStepInSeconds: 10,
  styles: null,
  hasSourceToggle: false,
  vocalsIcon: true
};

export default themeit(themeOptions)(MediaController);